module.exports = __webpack_public_path__ + "img/photo_default.9db6ec7a.jpg";